import { OPERATION_TYPES } from "../domain/valueObjects/operationTypes";

const normalizeSlug = (value) =>
  String(value || "")
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");

export const buildOrganizationSeed = (companyName) => {
  const slug = normalizeSlug(companyName || "default");

  return {
    id: slug || "default",
    slug: slug || "default",
    name: companyName || "Default",
    enabledModules: ["coreVoyage", "tankerOperations"],
  };
};

export const toV2OperationType = (value) =>
  value === "Discharging"
    ? OPERATION_TYPES.DISCHARGING
    : OPERATION_TYPES.LOADING;

export const toLegacyOperationType = (value) =>
  value === OPERATION_TYPES.DISCHARGING ? "Discharging" : "Loading";

export const mapTripCargoToLegacy = (cargo) => ({
  ...cargo,
  cargoId: cargo.id,
  cargo: cargo.productName,
  quantity: cargo.quantity ?? "",
  unit: cargo.unit,
  showTolerance: Boolean(cargo.showTolerance),
  tolerances: cargo.tolerances || [{ toleranceValue: "", toleranceUnit: "%" }],
});

export const mapTripToLegacy = (trip, cargos) => ({
  ...trip,
  tripId: trip.id,
  tripIndex: trip.sequence,
  date: trip.date,
  operationType: toLegacyOperationType(trip.operationType),
  from: trip.portNameSnapshot || "",
  to: trip.portNameSnapshot || "",
  cpDated: trip.charterPartyDate || "",
  supplierReceiver: trip.counterpartyNameSnapshot || "",
  jetty: trip.jettyNameSnapshot || "",
  cargos: cargos.map(mapTripCargoToLegacy),
  crew: {
    masterName: trip.masterSnapshot?.name || "",
    chiefOfficer: trip.chiefOfficerSnapshot?.name || "",
  },
  status: trip.status,
  amendDate: trip.amendedAt || "",
  amendReason: trip.amendmentReason || "",
  updatedAt: trip.updatedAt,
});

export const projectVoyageWorkspace = ({
  voyage,
  vesselName,
  trips,
  cargosByTripId,
}) => {
  const activeTrips = {};
  const amendedTrips = {};

  trips
    .slice()
    .sort((a, b) => a.sequence - b.sequence)
    .forEach((trip) => {
      const legacyTrip = mapTripToLegacy(trip, cargosByTripId[trip.id] || []);

      if (trip.status === "amended") {
        amendedTrips[trip.id] = legacyTrip;
      } else {
        activeTrips[trip.id] = legacyTrip;
      }
    });

  return {
    voyageId: voyage.id,
    id: voyage.id,
    voyageNumber: voyage.voyageNumber,
    vessel: vesselName,
    status: voyage.status,
    createdAt: voyage.createdAt,
    updatedAt: voyage.updatedAt,
    endedAt: voyage.completedAt || null,
    trips: activeTrips,
    amendedTrips,
    globalLogs: [],
  };
};
